export default __webpack_public_path__ + "static/media/prize-1-cn.a3b162ba.webp";